export default {
  en: {
    endingInventory: 'Ending Inventory',
    waste: 'Waste',
    foodOverBase: 'Food Over Base',
    fob: 'FOB',
    fobWithDisc: 'FOB W/ Disc',
    fobWithoutUnexp: 'FOB W/O Unexp',
    fobWithDiscWithoutUnexp: 'FOB W/ Disc & W/O Unexp',
    inventoryVariance: 'Inventory Variance',
  },
  es: {
    endingInventory: 'Inventario Final',
    waste: 'Desperdicio',
    foodOverBase: 'Alimento Sobre Base',
    fob: 'FOB',
    fobWithDisc: 'FOB C/ Desc',
    fobWithoutUnexp: 'FOB S/ Inexp',
    fobWithDiscWithoutUnexp: 'FOB C/ Desc & S/ Inexp',
    inventoryVariance: 'Variación de Inventario',
  },
};
